import { PublicKey } from "@solana/web3.js";

import { METADATA_PROGRAM_ID } from "./ids";

export const METADATA_PREFIX = "metadata";
export const EDITION = "edition";
export const RESERVATION = "reservation";

export enum MetadataKey {
  Uninitialized = 0,
  MetadataV1 = 4,
  EditionV1 = 1,
  MasterEditionV1 = 2,
  MasterEditionV2 = 6,
  EditionMarker = 7,
}

export enum MetadataCategory {
  Audio = "audio",
  Video = "video",
  Image = "image",
  VR = "vr",
}

export class Collection {
  verified: boolean;
  key: PublicKey;

  constructor(args: { verified: boolean; key: string }) {
    this.verified = args.verified;
    this.key = new PublicKey(args.key);
  }
}

export class Creator {
  address: PublicKey;
  verified: boolean;
  share: number;

  constructor(args: { address: PublicKey; verified: boolean; share: number }) {
    this.address = args.address;
    this.verified = args.verified;
    this.share = args.share;
  }
}

export function getEdition(nftMintAddress: PublicKey): PublicKey {
  return PublicKey.findProgramAddressSync(
    [Buffer.from(METADATA_PREFIX), METADATA_PROGRAM_ID.toBuffer(), nftMintAddress.toBuffer(), Buffer.from(EDITION)],
    METADATA_PROGRAM_ID,
  )[0];
}

export function getMetadata(nftMintAddress: PublicKey): PublicKey {
  return PublicKey.findProgramAddressSync(
    [Buffer.from(METADATA_PREFIX), METADATA_PROGRAM_ID.toBuffer(), nftMintAddress.toBuffer()],
    METADATA_PROGRAM_ID,
  )[0];
}

export function getTokenRecordPda(nftMintAddress: PublicKey, token: PublicKey) {
  return PublicKey.findProgramAddressSync(
    [
      Buffer.from(METADATA_PREFIX),
      METADATA_PROGRAM_ID.toBuffer(),
      nftMintAddress.toBuffer(),
      Buffer.from("token_record"),
      token.toBuffer(),
    ],
    METADATA_PROGRAM_ID,
  )[0];
}
